import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbImage } from '../../types/pbBlocks';
import { getAdvanced, getBorder, getButtonLinkType, parseStyleString } from '../utils';

export type ImageType = ContentTypeObject & PbImage;

/**
 * Aggregates the configuration of an image element.
 * @param node
 */
export function imageConfigAggregator(node: CustomHtmlElement): ImageType {
    let imageNodes = node.childNodes as CustomHtmlElement[];

    /**
     * If the image has a link then set the first child node is the anchor tag
     */
    const childNode = node.childNodes[0] as CustomHtmlElement;

    /**
     * Its children are then the desktop and mobile image tags
     */
    if (childNode.tagName === 'A') {
        imageNodes = childNode.childNodes as CustomHtmlElement[];
    }

    const desktopImage = imageNodes[0] as CustomHtmlElement;
    const mobileImage = imageNodes[1] as CustomHtmlElement;

    const style = parseStyleString(node.attributes.style);
    const desktopImageStyle = parseStyleString(desktopImage.attributes.style);

    const captionElement = node.querySelector('figcaption') as unknown as CustomHtmlElement | null;

    return {
        ...getAdvanced(node, style),
        ...getBorder(desktopImageStyle),
        altText: desktopImage ? desktopImage.attributes['alt'] : undefined,
        caption: captionElement?.textContent ?? undefined,
        desktopImage: desktopImage ? desktopImage.attributes['src'] : undefined,
        link: childNode.attributes['href'],
        linkType: getButtonLinkType(childNode.attributes['data-link-type']),
        mobileImage: mobileImage ? mobileImage.attributes['src'] : desktopImage.attributes['src'],
        openInNewTab: childNode.attributes['target'] === '_blank',
        title: desktopImage ? desktopImage.attributes['title'] : undefined,
        uniqueID: node.attributes['data-pb-style'],
    };
}
